import React from 'react';
import { motion } from 'framer-motion';
import { PRICE, choices } from '../data/offer';
import { Reveal } from './Reveal';
import { ArrowRightIcon, CheckIcon, CrossIcon } from './icons/CraftIcons';
export function Ultimatum() {
  return <section aria-labelledby="ultimatum" className="w-full border-y border-hairline bg-ivory px-4 py-10 sm:px-6 sm:py-14 lg:py-24" data-id="element-440" data-mp="3f7ffism6enyt">
      <div className="mx-auto max-w-[1120px]" data-id="element-441" data-mp="2mj0amywrdm17">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-442" data-mp="2mjt8fadqp177">
          <span className="inline-flex items-center gap-2 rounded-full border border-hairline bg-cream px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-ink-soft" data-id="element-443" data-mp="2ii80m3g2bd3v">
            <ArrowRightIcon className="h-3.5 w-3.5 text-sage" data-id="element-444" data-mp="2rimnv8cl72a0" />
            Section 5 — The ultimatum
          </span>
          <h2 id="ultimatum" className="mt-4 font-display text-3xl font-bold leading-tight text-ink sm:text-[38px]" data-id="element-445" data-mp="23s0fth2l1i00">
            Two choices. Both are fine. Only one is smart.
          </h2>
        </Reveal>

        <div className="perspective-stage mt-7 grid gap-4 sm:mt-10 sm:gap-6 lg:grid-cols-2" data-id="element-446" data-mp="ylk5xnkcgv23">
          {choices.map((choice, index) => {
          const isWin = choice.tone === 'win';
          const Icon = isWin ? CheckIcon : CrossIcon;
          return <motion.article key={choice.id} initial={{
            opacity: 0,
            y: 30,
            rotateY: isWin ? 6 : -6
          }} whileInView={{
            opacity: 1,
            y: 0,
            rotateY: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.7,
            delay: index * 0.12
          }} whileHover={{
            y: -6
          }} className={`flex h-full flex-col rounded-3xl border-2 p-5 sm:p-8 ${isWin ? 'border-sage bg-sage-tint/50 shadow-lift' : 'border-[#D9D3C4] bg-[#EDEAE1] shadow-soft'}`} data-id="element-447" data-mp="1d9op0snb78le" data-mpi={index}>
                <span className={`inline-flex w-fit items-center gap-2 rounded-full px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] ${isWin ? 'bg-sage text-white' : 'bg-[#DCD7C9] text-ink-soft'}`} data-id="element-448" data-mp="253z5f4trrshp">
                  <Icon className="h-3.5 w-3.5" data-id="element-449" data-mp="ex18lv2lgp4e" />
                  {choice.label}
                </span>
                <h3 className={`mt-4 font-display text-2xl font-extrabold ${isWin ? 'text-sage-dark' : 'text-ink-faint'}`} data-id="element-450" data-mp="9wn06bx2zd5u">
                  {choice.title}
                </h3>
                <ul className="mt-5 flex-1 space-y-3" data-id="element-451" data-mp="3s4m5xsqa4rye">
                  {choice.points.map(point => <li key={point.id} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink-soft" data-id="element-452" data-mp="3nckzwojpfxgt">
                      <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${isWin ? 'text-sage' : 'text-crimson/60'}`} data-id="element-453" data-mp="2upi3c1yl9wt7" />
                      {point.text}
                    </li>)}
                </ul>
                <p className={`mt-6 rounded-xl px-4 py-3 text-sm font-extrabold ${isWin ? 'bg-sage text-white' : 'bg-crimson-tint text-crimson'}`} data-id="element-454" data-mp="1171024mw48jd">
                  {choice.outcome}
                </p>
              </motion.article>;
        })}
        </div>

        <Reveal delay={0.15} data-id="element-455" data-mp="1jx8xc63ws4rn">
          <p className="mx-auto mt-6 max-w-2xl text-center text-sm leading-relaxed text-ink sm:mt-8 sm:text-base" data-id="element-456" data-mp="1jvxvibu0x736">
            If you choose Choice A, you are effectively choosing to stay broke. And at $
            {PRICE.today}
            <span className="font-bold" data-id="element-457" data-mp="8jnboux9clav">
              {' '}
              &mdash; that&rsquo;s a very expensive choice to make.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}